import { useLanguage } from "@/lib/i18n/LanguageContext";
import { getCategoryOptions } from "@/lib/utils/categories";
import { Link } from "react-router-dom";

function CotdPage() {
  const { t } = useLanguage();
  const categories = getCategoryOptions(t);

  return (
    <div className="cotd-container flex-1 flex flex-col p-4">
      <div className="cotd-content text-center w-full max-w-sm sm:max-w-lg lg:max-w-2xl mx-auto flex-1 flex flex-col">
        <div className="header-section mb-6">
          <p className="cotd-description mt-6 text-md sm:text-lg text-gray-600 dark:text-gray-400">
            {t("cotdDescription")}
          </p>
        </div>

        <div className="category-selection mb-4 space-y-3 px-4 sm:px-0 flex-1 flex flex-col justify-center">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/cotd/session?category=${category.id}`}
              className="category-link block"
            >
              <div
                className={`category-card category-${category.id} ${category.bgColor} border-2 ${category.borderColor} p-4 sm:p-6 ${category.hoverBg} hover:border-black dark:hover:border-gray-400 transition-all duration-200 mx-2 sm:mx-0`}
              >
                <h3
                  className={`category-name text-lg sm:text-xl font-medium mb-2 ${category.textColor}`}
                >
                  {category.name}
                </h3>
                <p
                  className={`category-description text-sm sm:text-base opacity-80 ${category.textColor}`}
                >
                  {category.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CotdPage;
